/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiCSVUploadSessionStatus;
(function (ApiCSVUploadSessionStatus) {
    ApiCSVUploadSessionStatus["PENDING"] = "CSV_UPLOAD_SESSION_STATUS_PENDING";
    ApiCSVUploadSessionStatus["PROCESSED"] = "CSV_UPLOAD_SESSION_STATUS_PROCESSED";
    ApiCSVUploadSessionStatus["FAILED"] = "CSV_UPLOAD_SESSION_STATUS_FAILED";
})(ApiCSVUploadSessionStatus || (ApiCSVUploadSessionStatus = {}));
export function ApiCSVUploadSessionStatusFromJSON(json) {
    return ApiCSVUploadSessionStatusFromJSONTyped(json, false);
}
export function ApiCSVUploadSessionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiCSVUploadSessionStatusToJSON(value) {
    return value;
}
